module.exports = __webpack_public_path__ + "media/images/slide-8-976eca21b067cad7ab7404bdb7bb707a.jpg";